// extracted by mini-css-extract-plugin
var _1 = "AppointmentsSection-modulebody__qwnjt SettingsFormSectionContent-modulebody__Hug4g";
var _2 = "AppointmentsSection-modulefieldSkeleton__Li0d0 SettingsField-moduleSettingsField__fY88b Field-moduleField__kZH_K";
export { _1 as "body", _2 as "fieldSkeleton" }
